import SiteConfig from '../../config/sites'
import {
  Consent,
  deferRun,
  userHasOptedOutOfCookiesForCategory
} from './consent'

const loadScript = (src: string) => {
  const scriptTag = document.createElement('script')
  const firstScriptTag = document.getElementsByTagName('script')[0]

  scriptTag.async = true
  scriptTag.src = src
  if (firstScriptTag && firstScriptTag.parentNode) {
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag)
  }
}

export const deferLoadGTMScript = () => {
  deferRun(() => {
    const w = window as any
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })

    const containerId = SiteConfig.defaults.google_tag_manager_id
    loadScript(`https://www.googletagmanager.com/gtm.js?id=${containerId}`)
  }, Consent.marketing)
}

export const deferLoadGoogleAnalytics = () => {
  const userHasOptedOutOfCookiesForGA = userHasOptedOutOfCookiesForCategory(
    Consent.statistics
  )

  // Set an exception for GA.
  // Load GA by default if user has no consent
  // Don't load GA if user has explicity opted out for `statistics` category,
  if (!userHasOptedOutOfCookiesForGA) {
    loadScript('https://www.google-analytics.com/analytics.js')
  }
}
